import { ICONS_NAME } from './icons.constants';
import { Alignment } from './types.utils';

export const TABS_PROPS = {
    align: Alignment.LEFT,
    breakpoint: 0,
    class: 'text-body1',
    dense: true,
    indicatorColor: 'primary',
    inlineLabel: true,
    leftIcon: ICONS_NAME.CHEVRON_LEFT_SOLID,
    mobileArrows: true,
    noCaps: true,
    outsideArrows: true,
    rightIcon: ICONS_NAME.CHEVRON_RIGHT_SOLID
};

export const TAB_PANELS = {
    animated: true,
    class: 'bg-grey-light-lighter q-pt-lg',
    keepAlive: false,
    transitionNext: 'fade',
    transitionPrev: 'fade'
};

export const TAB_PANELS_DIALOG = {
    animated: true,
    class: 'q-pt-lg',
    keepAlive: false,
    transitionNext: 'fade',
    transitionPrev: 'fade'
};

export const TAB_PANEL = {
    class: 'q-pa-none'
};
